let apiUrl = process.env.VUE_APP_API_CC;
import { decrypt } from "../vendor/crypto";
import { redirectToIndex } from "@/shared/redirectToIndex";
import { extractErrCode, normalizePayload } from "@/shared/responsePayload";

const redirectOnError = response => {
  if (response) {
    response.data = normalizePayload(response.data);
  }

  if (Number(extractErrCode(response && response.data)) === 999) {
    redirectToIndex("config-center-errCode-999", {
      url: response && response.config && response.config.url,
    });
  }
  return response;
};

class CC {
  static getInfos(data, refresh) {
    if (data.eventId) {
      data.eventId = data.eventId.map(id =>
        /^e[0-9]{9}$/.test(id) ? id : decrypt(id)
      );
    }
    if (data.sessionId) {
      data.sessionId = data.sessionId.map(id =>
        /^s[0-9]{9}$/.test(id) ? id : decrypt(id)
      );
    }
    let params = {};
    for (const key in data) {
      params[key] = data[key].toString();
    }
    return axios
      .get(
        `${apiUrl}/get?${new URLSearchParams(params).toString()}&${
          refresh ? `reload=false` : ""
        }`
      )
      .then(res_data => [redirectOnError(res_data), undefined])
      .catch(error => Promise.resolve([undefined, error]));
  }
}

export default CC;
